import { type ReactNode, useEffect, useId, useRef } from "react";
import { attachSheetHistory } from "../lib/sheet-history";
export function BottomSheet({
	title,
	onClose,
	children,
}: {
	title: string;
	onClose: () => void;
	children: ReactNode;
}) {
	const ref = useRef<HTMLDialogElement>(null);
	const titleId = useId();
	const closeRef = useRef(onClose);
	closeRef.current = onClose;
	useEffect(() => {
		const previous = document.activeElement;
		ref.current?.showModal();
		const releaseHistory = attachSheetHistory(history, window, () => closeRef.current());
		return () => {
			releaseHistory();
			ref.current?.close();
			if (previous instanceof HTMLElement) previous.focus();
		};
	}, []);
	return (
		<dialog
			className="bottom-sheet"
			ref={ref}
			aria-labelledby={titleId}
			onCancel={(event) => {
				event.preventDefault();
				onClose();
			}}
		>
			<header className="inline">
				<h2 id={titleId}>{title}</h2>
				<button className="button" type="button" onClick={onClose}>
					닫기
				</button>
			</header>
			{children}
		</dialog>
	);
}
